import dayjs from '@common/utils/dayjs';

export const setup = (locale, i18n) => {
  dayjs.locale(locale);
  dayjs.updateLocale(locale, {
    calendar: {
      nextDay: `[${i18n.t('common:utils_date_tomorrow_at')}] LT`,
      nextWeek: `dddd [${i18n.t('common:utils_date_at')}] LT`,
      sameDay: function callback(now) {
        const diff = now.diff(this, 'seconds');

        if (diff > 0 && diff < 60) return i18n.t('common:utils_date_just_now');

        return this.fromNow();
      },
      lastDay: `dddd [${i18n.t('common:utils_date_at')}] LT`,
      lastWeek: `dddd [${i18n.t('common:utils_date_at')}] LT`,
      // Dayjs uses a calendar function's return value as the final string.
      sameElse: function callback(now) {
        const pattern = now.year() !== this.year()
          ? `D MMMM YYYY [${i18n.t('common:utils_date_at')}] LT`
          : `D MMMM [${i18n.t('common:utils_date_at')}] LT`;
        return this.format(pattern);
      },
    },
    relativeTime: {
      past: function callback(string) {
        return string === i18n.t('common:utils_date_just_now') ? string : `${string} ${i18n.t('common:utils_date_ago')}`;
      },
      s: function callback(number, withoutSuffix, key, isFuture) {
        return isFuture ? i18n.t('common:utils_date_in_seconds', { count: number }) : i18n.t('common:utils_date_just_now');
      },
    },
  });
};
